export default __webpack_public_path__ + "static/media/partner-5.55753a06.jpg";